import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {i18nMixin} from '@aofl/i18n-mixin';
import translations from '../i18n';

/**
 * @summary DeleteConfirmation
 * @extends {i18nMixin(AoflElement)}
 */
@customElement('archive-confirmation')
class ArchiveConfirmation extends i18nMixin(AoflElement) {
  /**
   * @readonly
   */
  static is = 'archive-confirmation';

  @property({type: Boolean, attribute: true})
  submitting = false;

  /**
   * Creates an instance of ArchiveConfirmation.
   */
  constructor() {
    super();
    this.translations = translations;
  }

  @property({type: Object, attribute: true})
  data = {};

  cancel() {
    this.dispatchEvent(new CustomEvent('cancel'));
  }

  submit() {
    this.dispatchEvent(new CustomEvent('submit'));
  }

  /**
   * @return {Object}
   */
  render() {
    return super.render({
      default: {template, styles: [styles]}
    });
  }
}

export default ArchiveConfirmation;
